import * as React from "react";
// import Popper from 'popper.js';
import { Country, Product } from "../types";
import CountryList from "../Controls/CountryList";
import MaskedInput from 'react-text-mask';
import t from "../i18n";
import Img from "../Controls/Img";
import { isMobileNumberValid, getInvalidMobileNumberReason } from "../utils";

declare type NumberProps = {
    countries: Country[],
    country: Country | undefined,
    product: Product | undefined,
    mobileNumber: string,
    onMobileNumberChanged: (mobileNumber: string) => void,
    onCountrySelected: (country: Country | undefined) => void;
    onDropdownChanged?: (isOpen: boolean) => void;
    showPlaceholder?: boolean | true;
    mobileBoxStyleCustom?: React.CSSProperties;
    focusOnMe?: boolean | true;
}
declare type NumberState = {
    countryChangePromptActive: boolean,
    message: string;
}
export default class Number extends React.Component<NumberProps, NumberState> {
    private _maskRef: HTMLInputElement | null;
    readonly state: NumberState = { countryChangePromptActive: false, message: t.topup("select_country") };
    assignMaskRef = (element: MaskedInput | null) => {
        if (element) {
            if (!this.props.focusOnMe) return;
            // tslint:disable-next-line:no-string-literal
            // @ts-ignore
            this._maskRef = element["inputElement"];
            this._maskRef!.focus();
        } else {
            element = null;
        }
    }
    get countryChangePromptActive() {
        return this.state.countryChangePromptActive;
    }
    set countryChangePromptActive(value: boolean) {
        this.setState({ countryChangePromptActive: value });
        if (this.props.onDropdownChanged) this.props.onDropdownChanged(value);
    }
    focus = () => {
        if (this._maskRef) this._maskRef.focus();
    }
    onMobileNumberChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
        const mobileNumber = e.target.value;
        if (this.props.onMobileNumberChanged) this.props.onMobileNumberChanged(mobileNumber);
    }
    openCountryList = (e: React.MouseEvent<HTMLElement>) => {
        const inCountryList = (e.target as HTMLElement).closest(".country-list");
        if (inCountryList) return;
        this.countryChangePromptActive = true;
    }
    closeCountryList = () => {
        this.countryChangePromptActive = false;
    }
    onCountrySelected = (country: Country | undefined) => {
        if (this._maskRef) this._maskRef.focus();
        this.countryChangePromptActive = false;
        if (this.props.onCountrySelected && this.props.country !== country) {
            this.props.onCountrySelected(country);
        }
    }
    renderWithoutCountry() {
        return <div style={{ ...mobileBoxStyle, cursor: "default" }}
            className="form-control d-flex align-items-center number-box-div" onClick={this.openCountryList}>
            <Img style={{ ...flagStyle, width: 24, marginRight: 10 }} src="/images/countries/globe-title.png" />
            <div style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }} >
                {t.topup("click_select_country")}
            </div>
            {this.countryChangePromptActive && this.renderCountryDropdown()}
        </div>
    }
    renderWithCountry() {
        const country = this.props.country!;
        const maxLength = country ? Math.max(...country.localNumberLength.split(",").map(l => parseInt(l, 10))) : 11;
        const mask = [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/].splice(0, maxLength);
        const countryCodeDigitsCount = country.internationalCode.toString().length;
        let showPlcholder = this.props.showPlaceholder;
        if (showPlcholder === undefined) {
            showPlcholder = true;
        }
        let mobileBoxStyl = mobileBoxStyle;
        if (this.props.mobileBoxStyleCustom) {
            mobileBoxStyl = { ...mobileBoxStyle, ...this.props.mobileBoxStyleCustom };
        }
        return <div style={mobileBoxStyl}
            className="d-flex align-items-center number-box-div">
            <MaskedInput ref={this.assignMaskRef} type="tel" className="form-control enter-number-box"
                mask={mask} guide={false} keepCharPositions={true}
                placeholder={showPlcholder && t.topup("enter_mobile_number") || ''} maxLength={maxLength}
                style={{ ...mobileInputStyle, paddingLeft: 95 + countryCodeDigitsCount * 10 }}
                value={this.props.mobileNumber || ""} onChange={this.onMobileNumberChanged} />
            <div className="d-flex align-items-center" style={countryGroupStyle} onClick={this.openCountryList}>
                <Img style={flagStyle} src={`/images/1x/countries-mobile/${country.countryCode}.jpg`} />
                <div>+{country.internationalCode}</div>
                <div style={dividerStyle} />
            </div>
            {this.countryChangePromptActive && this.renderCountryDropdown()}
        </div>
    }
    renderCountryDropdown() {
        if (this.props.countries.length < 2) return null;
        return <div className="country-list" style={countryListStyle}>
            <CountryList
                countries={this.props.countries}
                selectedCountry={this.props.country}
                onCountrySelected={this.onCountrySelected}
            />
        </div>;
    }
    formMessage = () => {
        const { country, product, mobileNumber } = this.props;
        if (!country) return t.topup("select_country");
        if (!mobileNumber) return t.topup("enter_mobile_number");
        if (!isMobileNumberValid(country, product, mobileNumber)) {
            return getInvalidMobileNumberReason(country, product, mobileNumber);
        }
        return null;
    }
    render() {
        return (
            <React.Fragment>
                {this.props.country && this.renderWithCountry()}
                {!this.props.country && this.renderWithoutCountry()}
                <div className="red-text font-italic">{this.formMessage()}</div>
            </React.Fragment>
        )
        return this.props.country ? this.renderWithCountry() : this.renderWithoutCountry();
    }
}
const mobileBoxStyle: React.CSSProperties = {
    height: 54,
    position: "relative",
    paddingLeft: 0,
    fontSize: "24px",
    overflow: "visible",
}
const flagStyle: React.CSSProperties = {
    height: 24,
    width: 36,
    marginLeft: 15,
    marginRight: 5,
}
const mobileInputStyle: React.CSSProperties = {
    paddingLeft: 125,
    height: "100%",
    fontSize: "24px",
    fontWeight: 600,
}
const countryListStyle: React.CSSProperties = {
    maxHeight: 224,
    border: "1px solid #ddd",
    padding: 2,
    backgroundColor: "#fff",
    overflow: "auto",
    zIndex: 2,
    position: "absolute",
    top: "100%",
    left: -1,
    right: -1,
    fontSize: "1rem",
}
const countryGroupStyle: React.CSSProperties = {
    position: "absolute",
    height: "100%",
    top: 0,
    cursor: "pointer",
    left: 0,
}
const dividerStyle: React.CSSProperties = {
    width: 1,
    borderRight: "1px solid #ddd",
    height: 25,
    marginLeft: 8
}
